// The site's top-level pages, in header and footer order. `short` is the
// label on narrow screens where the full one would push the logo off.
export const NAV_LINKS = [
  { to: '/download', label: 'Download', short: 'Download' },
  { to: '/install', label: 'Set up a display', short: 'Set up' },
];
